import UIProductBanner, {
  ProductBannerProps,
} from '@repo/ui/src/components/ContentGrid/ProductBanner';
import { useVipAccess } from '@hooks/customer';

const ProductBanner = (props: Omit<ProductBannerProps, 'vip'>) => {
  const { vip } = useVipAccess();
  return <UIProductBanner {...props} vip={vip} />;
};

export default ProductBanner;
